import React from 'react';
export function WhatYouGet() {
  const deliverables = [{
    title: "La Guía Maestra 'Mente de Campeón Inquebrantable'",
    desc: 'El manual principal en formato PDF con toda la metodología.'
  }, {
    title: "Protocolo 'El Viaje a Casa'",
    desc: 'Qué decir exactamente en el auto tras una derrota para construir resiliencia.'
  }, {
    title: 'El Método Reset',
    desc: 'Guía paso a paso para que el niño use durante la competencia.'
  }, {
    title: 'Diario de Victorias Invisibles',
    desc: 'Plantilla práctica para construir una autoestima sólida día a día.'
  }, {
    title: 'Checklist Pre-Partido',
    desc: 'Herramienta para padres para reducir la ansiedad ambiental antes de competir.'
  }];
  return <section className="py-24 px-4 bg-warm-light" data-id="element-155">
      <div className="max-w-5xl mx-auto" data-id="element-156">
        <h2 className="text-4xl md:text-5xl font-black text-center text-warm-dark mb-16" data-id="element-157">
          Lo Que Obtienes Hoy
        </h2>

        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-158">
          <div className="space-y-0" data-id="element-159">
            {deliverables.map((item, index) => <div key={index} className="flex gap-5 items-start py-5 border-b border-warm-dark/10 last:border-b-0" data-id="element-160">
                <span className="font-heading font-bold text-warm-dark/30 text-lg shrink-0 mt-0.5" data-id="element-161">
                  →
                </span>
                <div data-id="element-162">
                  <h3 className="text-base font-heading font-bold text-warm-dark" data-id="element-163">
                    {item.title}
                  </h3>
                  <p className="text-warm-mid text-sm mt-1" data-id="element-164">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="hidden md:block" data-id="element-165">
            <img src="https://cdn.magicpatterns.com/uploads/1WSyFrSao2CF5DLJvyKK6j/heylloyd-image-1772653878930.png" alt="Mente de Campeón Inquebrantable" className="w-full h-auto" data-id="element-166" />
          </div>
        </div>
      </div>
    </section>;
}